import { Microphone01Icon } from "Icons/Microphone01";
import { MicrophoneOff01Icon } from "Icons/MicrophoneOff01";
import { VideoRecorderIcon } from "Icons/VideoRecorder";
import { VideoRecorderOffIcon } from "Icons/VideoRecorderOff";

import {  useEffect } from "react";

import { Button } from "components/shared/library/Button";
import { MenuBarAction } from "components/shared/library/MenuBarAction";
import { MoreActionButton } from "components/shared/library/MoreActionButton";

import { useInterview } from "contexts/InterviewContext";
import { useAlert } from "contexts/alertContext";

import { isViewMobile } from "utils/mediaQueryStrings";

export const MuteButtons = ({
  toggleAudioMute,
  toggleVideoPause,
  isAudioMuted,
  isVideoPaused,
}: {
  toggleAudioMute: () => void;
  toggleVideoPause: () => void;
  isAudioMuted: boolean;
  isVideoPaused: boolean;
}) => {
  const { isVideoEnabled } = useInterview();

  const { createAlert } = useAlert();

  useEffect(() => {
    // when pausing the video we should show the alert
    if (isVideoPaused) {
      createAlert(
        "warning",
        "Turning off your video for more than 30 seconds may affect your candidacy."
      );
    }
  }, [createAlert, isVideoPaused]);

  const AudioIcon = isAudioMuted ? MicrophoneOff01Icon : Microphone01Icon;
  const audioLabel = isAudioMuted ? "Unmute audio" : "Mute audio";
  const VideoIcon = isVideoPaused ? VideoRecorderOffIcon : VideoRecorderIcon;
  const videoLabel = isVideoPaused ? "Resume video" : "Pause video";

  if (isViewMobile()) {
    return (
      <MoreActionButton
        buttonProps={{ color: "black", background: "filled", size: "large" }}
        MenuItems={({ onClick }) => (
          <>
            <MenuBarAction
              onClick={() => {
                toggleAudioMute();
                onClick();
              }}
              label={audioLabel}
              LeftComponent={<AudioIcon width={20} height={20} />}
            />
            {isVideoEnabled && (
              <MenuBarAction
                onClick={() => {
                  toggleVideoPause();
                  onClick();
                }}
                label={videoLabel}
                LeftComponent={<VideoIcon width={20} height={20} />}
              />
            )}
          </>
        )}
      />
    );
  }
  return (
    <>
      <Button
        IconLeft={AudioIcon}
        color="black"
        background={isAudioMuted ? "outlined" : "filled"}
        onClick={toggleAudioMute}
        size="large"
        ariaLabel={audioLabel}
      />
      {isVideoEnabled && (
        <Button
          IconLeft={VideoIcon}
          color="black"
          background={isVideoPaused ? "outlined" : "filled"}
          onClick={toggleVideoPause}
          size="large"
          ariaLabel={videoLabel}
        />
      )}
    </>
  );
};
